export var ReservationsDecouplingPhase;
(function(ReservationsDecouplingPhase) {
    ReservationsDecouplingPhase["PHASE_ONE"] = "PHASE_ONE";
    ReservationsDecouplingPhase["PHASE_TWO"] = "PHASE_TWO";
})(ReservationsDecouplingPhase || (ReservationsDecouplingPhase = {}));
